var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error__wrapper"},[_c('h1',{staticClass:"error__title"},[_vm._v("Страница уехала...")]),_c('p',{staticClass:"error__text"},[_vm._v(" Прекрасная страница, каких больше не делают... Но вы на верном пути. ")])])])
}]

export { render, staticRenderFns }